import { TAGS } from "../constants";
import {
  CreatePatientAddress,
  ShippingAddress,
  UpdatePatientAddress,
} from "../types";
import { api } from "./api";

export const addressApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientAddress: builder.query<ShippingAddress, number>({
      query: (patientId) => ({
        url: `/api/shipping-address/patient/${patientId}`,
        method: "GET",
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PATIENT_ADDRESS, id: args },
      ],
    }),

    updatePatientAddress: builder.mutation<
      ShippingAddress,
      UpdatePatientAddress
    >({
      query: ({ patient_id, ...body }) => ({
        url: `/api/shipping-address/patient/${patient_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        {
          type: TAGS.PATIENT_ADDRESS,
          id: args.patient_id,
        },
        {
          type: TAGS.PATIENT,
          id: args.patient_id,
        },
      ],
    }),
    AddPatientAddress: builder.mutation<ShippingAddress, CreatePatientAddress>({
      query: ({ patient_id, ...body }) => ({
        url: `/api/shipping-address/patient/${patient_id}`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        {
          type: TAGS.PATIENT_ADDRESS,
          id: args.patient_id,
        },
        {
          type: TAGS.PATIENT,
          id: args.patient_id,
        },
      ],
    }),
  }),
});

export const {
  useGetPatientAddressQuery,
  useUpdatePatientAddressMutation,
  useAddPatientAddressMutation,
} = addressApi;
